import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import DashboardHeader from "../../components/common/DashboardHeader/DashboardHeader";
import Sidebar from "../../components/common/Sidebar/Sidebar";
import DashboardFooter from "../../components/common/DashboardFooter/DashboardFooter";
import styles from "./DashboardLayout.module.css";

const LayoutContent = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const handleMenuClick = () => setIsSidebarVisible(prev => !prev);
  const handleNavItemClick = () => {
    if (window.innerWidth <= 768) setIsSidebarVisible(false);
  };

  return (
    <Box className={styles.dashboardContainer}>
      <DashboardHeader onMenuClick={handleMenuClick} />
      <Box className={styles.mainContent}>
        <Sidebar
          className={isSidebarVisible ? 'visible' : ''}
          onNavItemClick={handleNavItemClick}
          isVisible={isSidebarVisible}
        />
        <Box className={styles.contentArea}>
          <Outlet />
        </Box>
      </Box>
      <DashboardFooter />
    </Box>
  );
};

const DashboardLayout = () => (
    <LayoutContent />
);

export default DashboardLayout;